import SubscriptionProfileToken from '@apps/truevail/admin/tokens/subscription_profile'
import TimeFrameField from '@apps/truevail/admin/components/timeframefield'
import SchedulingToken from '@apps/truevail/admin/tokens/scheduling'
import ChannelToken from '@apps/truevail/admin/tokens/channel'
import Container from '@admin/components/container'
import ProfileToken from '@admin/tokens/profile'
import Form from '@admin/components/form'
import PropTypes from 'prop-types'
import React from 'react'

class Details extends React.Component {

  static contextTypes = {
    admin: PropTypes.object
  }

  static propTypes = {
    formdata: PropTypes.object,
    profiles: PropTypes.array,
    props: PropTypes.object,
    setup: PropTypes.object,
    onBack: PropTypes.func,
    onCancel: PropTypes.func,
    onChange: PropTypes.func,
    onNext: PropTypes.func,
    onSave: PropTypes.func
  }

  formRef = React.createRef()

  state = {
    config: {}
  }

  _handleBack = this._handleBack.bind(this)
  _handleChange = this._handleChange.bind(this)
  _handleSubmit = this._handleSubmit.bind(this)
  _handleSuccess = this._handleSuccess.bind(this)

  render() {
    return <Form { ...this._getForm() } />
  }

  _getForm() {
    const { formdata, profiles, props, setup } = this.props
    const { configuration } = setup
    const { config } = this.state
    const { advisor } = props
    const { type } = formdata

    return {
      ref: this.formRef,
      showHeader: false,
      buttons: [
        { label: 't(Previous)', color: 'blue', basic: true, handler: this._handleBack },
        { label: 't(Save)', color: 'blue', handler: this._handleSubmit }
      ],
      onChange: this._handleChange,
      onSuccess: this._handleSuccess,
      sections: [
        {
          fields: type === 'email' ? [
            { name: 'type', type: 'hidden', value: 'email' },
            { label: 't(Sender)', name: 'sender_id', type: 'dropdown', entity: 'sender', endpoint: `/api/admin/truevail/admin/advisors/${advisor.id}/senders`, valueKey: 'id', textKey: 'rfc822', selectFirst: true, required: true },
            { label: 't(List)', name: 'list_id', type: 'dropdown', entity: 'list', endpoint: `/api/admin/truevail/admin/advisors/${advisor.id}/lists`, valueKey: 'id', textKey: 'title', selectFirst: true, required: true },
            { label: 't(Email Template)', name: 'email_template_id', type: 'dropdown', entity: 'template', endpoint: `/api/admin/truevail/admin/advisors/${advisor.id}/templates`, valueKey: 'id', textKey: 'title', selectFirst: true, required: true },
            { label: 't(Scheduling)', name: 'scheduling', type: 'radiogroup', options: ['optout','optin'], format: SchedulingToken, required: true, defaultValue: configuration.email_scheduling || 'optout' },
            { label: 't(Reply To URL)', name: 'config.reply_to_url', type: 'urlfield', placeholder: 'https://your-website.com/contact' },
            { label: 't(Channels)', name: 'channel_ids', type: 'checkboxgroup', entity: 'channel', endpoint: `/api/admin/truevail/admin/advisors/${advisor.id}/channels`, valueKey: 'id', textKey: 'title', filter: { service: { $eq: 'email' } }, format: (channel) => (
              <ChannelToken channel={ channel } />
            ), defaultValue: configuration.email_channel_ids || [] }
          ] : type === 'social' ? [
            { 
              name: 'type', 
              type: 'hidden',
              value: 'social' 
            },
            { 
              label: 't(Profiles)', 
              name: 'subscription_profiles', 
              type: 'collectionfield', 
              fields: [
                { 
                  label: 't(Profile)', 
                  name: 'profile_id', 
                  type: 'dropdown', 
                  options: profiles, 
                  valueKey: 'id', 
                  textKey: 'username', 
                  format: (profile) => (
                    <ProfileToken profile={ profile } />
                  ), 
                  placeholder: 't(Choose a profile)', 
                  required: true 
                },
                { 
                  label: 't(Hashtags)', 
                  name: 'hashtags', 
                  type: 'textfield' 
                }
              ], 
              entity: 'profile', 
              orderable: false, 
              cloneable: false, 
              token: ({ value }) => (
                <SubscriptionProfileToken { ...this._getSubscriptionProfile(value) } />
              ), 
              defaultValue: configuration.social_profiles?.filter(social_profile => {
                return profiles.find(profile => {
                  return profile.id === social_profile.profile.id
                }) !== undefined
              }).map(social_profile => ({
                profile_id: social_profile.profile.id,
                hashtags: social_profile.hashtags
              })), 
              required: true 
            },
            { label: 't(Scheduling)', type: 'segment', fields: [
              { name: 'scheduling', type: 'radiogroup', options: ['optout','optin'], format: SchedulingToken, defaultValue: 'optout', required: true },
              { name: 'scheduling_timeframe', type: TimeFrameField, show: config.scheduling === 'optout', required: true },
              {
                prompt: 't(Allow Randomization)',
                name: 'allow_randomization',
                type: 'checkbox',
                defaultValue: false
              }
            ], required: true },
            { label: 't(Channels)', name: 'channel_ids', type: 'checkboxgroup', entity: 'channel', endpoint: `/api/admin/truevail/admin/advisors/${advisor.id}/channels`, valueKey: 'id', textKey: 'title', filter: { service: { $eq: 'social' } }, format: (channel) => (
              <ChannelToken channel={ channel } />
            ), defaultValue: configuration.social_channel_ids || [] },
            { label: 't(Before Caption)', name: 'config.before_caption', type: 'textarea' },
            { label: 't(After Caption)', name: 'config.after_caption', type: 'textarea' },
            {
              prompt: 't(Share Reels to Instagram Feed)',
              name: 'config.share_reels_to_instagram_feed',
              type: 'checkbox',
              defaultValue: true
            }
          ] : type === 'legacy_website' ? [
            { 
              name: 'type', 
              type: 'hidden', 
              value: 'legacy_website' 
            },
            { 
              label: 't(URL)',
              name: 'url',
              type: 'urlfield',
              required: true
            },
            { 
              label: 't(Login URL)',
              name: 'login_url',
              type: 'urlfield'
            } 
          ] : [],
          ...['email','social'].includes(type) ? [
            { 
              label: 't(Target Language)', 
              name: 'target_language', 
              type: 'dropdown', 
              options: [
                { text: 'Dutch', value: 'dutch' },
                { text: 'French', value: 'french' },
                { text: 'German', value: 'german' },
                { text: 'Italian', value: 'italian' },
                { text: 'Polish', value: 'polish' },
                { text: 'Portuguese', value: 'portuguese' },
                { text: 'Romanian', value: 'romanian' },
                { text: 'Russian', value: 'russian' },
                { text: 'Spanish', value: 'spanish' }
              ]
            }
          ] : []
        }
      ]
    }
  }

  _getSubscriptionProfile(value) {
    const { profiles } = this.props
    const profile = profiles.find(profile => {
      return profile.id === value.profile_id
    })
    return {
      profile,
      hashtags: value.hashtags
    }
  }

  _handleBack() {
    this.props.onBack()
  }

  _handleChange(config) {
    this.setState({ config })
  }

  _handleSubmit() {
    this.formRef.current.submit()
  }

  _handleSuccess(subscription) {
    this.props.onSave(subscription)
  }

}

const mapResources = (props, context) => ({
  ...props.formdata.type === 'social' ? {
    profiles: `/api/admin/truevail/admin/advisors/${props.props.advisor.id}/profiles`
  } : {},
  setup: `/api/admin/truevail/admin/advisors/${props.props.advisor.id}/configuration`
})

export default Container(mapResources)(Details)
